
<mat-form-field
    appearance="standard"
    class="input-form"
    (click)="picker.open()"
    aria-autocomplete="none"
>
    <mat-label translate>{{ label }}</mat-label>
    <input 
        #input
        matInput 
        class="input"
        [formControl]="control" 
        placeholder="{{ placeholder }}"
        [matDatepicker]="picker" 
        [min]="min"
        [max]="max"
        (focus)="picker.open()"
        disableRipple
    >
    <div matSuffix *ngIf="icon" class="icon icon-{{ icon }}"></div>
    <mat-datepicker #picker startView="multi-year" [startAt]="startDate"></mat-datepicker>
    <mat-error *ngIf="error">
        {{ error }}
    </mat-error>
</mat-form-field>
